import { useState } from 'react';

const TeamSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const teamMembers = [
    {
      id: 1,
      name: 'Михаил Репников',
      position: 'Со-основатель и гид',
      image: 'https://public.readdy.ai/ai/img_res/31b411ce727b4cdf157f19a9469ebe61.jpg',
      quote: 'Каждое путешествие — это возможность открыть в себе что-то новое'
    },
    {
      id: 2,
      name: 'Анна Соколова',
      position: 'Руководитель туров',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20tour%20leader%20waist-up%20portrait%2C%20confident%20woman%20in%20outdoor%20adventure%20gear%2C%20mountain%20landscape%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20warm%20friendly%20smile&width=650&height=400&seq=team-member-2&orientation=landscape',
      quote: 'Я помогаю людям находить свои мечты в горах и воплощать их в реальность'
    },
    {
      id: 3,
      name: 'Дмитрий Кузнецов',
      position: 'Горный гид-проводник',
      image: 'https://readdy.ai/api/search-image?query=Experienced%20male%20mountain%20guide%20waist-up%20portrait%2C%20rugged%20outdoor%20professional%20in%20hiking%20gear%2C%20alpine%20mountain%20scenery%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20determined%20confident%20expression&width=650&height=400&seq=team-member-3&orientation=landscape',
      quote: 'Безопасность и незабываемые впечатления — наш главный приоритет'
    },
    {
      id: 4,
      name: 'Елена Морозова',
      position: 'Специалист по экотуризму',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20ecotourism%20specialist%20waist-up%20portrait%2C%20nature-loving%20woman%20in%20eco-friendly%20outdoor%20clothing%2C%20forest%20and%20mountain%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20passionate%20enthusiastic%20expression&width=650&height=400&seq=team-member-4&orientation=landscape',
      quote: 'Природа — наш дом, и мы должны путешествовать с уважением к ней'
    },
    {
      id: 5,
      name: 'Алексей Волков',
      position: 'Фотограф экспедиций',
      image: 'https://readdy.ai/api/search-image?query=Professional%20expedition%20photographer%20waist-up%20portrait%2C%20creative%20man%20with%20camera%20equipment%2C%20dramatic%20mountain%20landscape%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20artistic%20focused%20expression&width=650&height=400&seq=team-member-5&orientation=landscape',
      quote: 'Каждый кадр должен передавать эмоции и красоту момента'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= teamMembers.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? teamMembers.length - 1 : prev - 1));
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const currentMember = teamMembers[currentSlide];

  return (
    <section className="bg-[#23a4e536] py-16 md:py-20 lg:py-24" aria-labelledby="team-heading">
      <div className="max-w-[1360px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Левая часть - заголовок и описание */}
          <div className="lg:pr-8">
            <h2 id="team-heading" className="font-mulish font-bold text-3xl lg:text-4xl xl:text-5xl text-gray-900 mb-6 leading-tight">
              Делимся тем, что любим сами
            </h2>
            <div className="space-y-6">
              <p className="font-open-sans text-lg lg:text-xl text-gray-700 leading-relaxed">
                Наша команда — это профессиональные гиды, инструкторы и путешественники, которые знают каждый маршрут изнутри.
              </p>
              <p className="font-open-sans text-lg lg:text-xl text-gray-700 leading-relaxed">
                Мы не просто организуем поездки — мы делимся своей страстью к путешествиям и открываем вам мир таким, каким видим его сами.
              </p>
              
              {/* Статистика команды */}
              <div className="grid grid-cols-3 gap-6 pt-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-team-line text-2xl text-white"></i>
                  </div>
                  <div className="font-mulish font-bold text-2xl text-gray-900">15+</div>
                  <div className="font-open-sans text-sm text-gray-600">Экспертов</div>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <div className="font-mulish font-bold text-2xl text-gray-900">200+</div>
                  <div className="font-open-sans text-sm text-gray-600">Маршрутов</div>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-star-line text-2xl text-white"></i>
                  </div>
                  <div className="font-mulish font-bold text-2xl text-gray-900">8+</div>
                  <div className="font-open-sans text-sm text-gray-600">Лет опыта</div>
                </div>
              </div>
            </div>
          </div>

          {/* Правая часть - слайдер с одной карточкой */}
          <div className="relative" aria-live="polite" aria-label="Слайдер команды">
            {/* Карточка сотрудника */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              {/* Фото */}
              <div className="relative h-80 lg:h-96 overflow-hidden">
                <img
                  src={currentMember.image}
                  alt={`Фото ${currentMember.name}`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              {/* Содержание карточки */}
              <div className="p-6 lg:p-8">
                <h3 className="font-mulish font-bold text-xl lg:text-2xl text-gray-900 mb-2">
                  {currentMember.name}
                </h3>
                <p className="font-open-sans text-sm lg:text-base text-emerald-600 mb-4 font-semibold">
                  {currentMember.position}
                </p>
                <blockquote className="font-open-sans text-sm lg:text-base text-gray-700 leading-relaxed italic">
                  "{currentMember.quote}"
                </blockquote>
              </div>
            </div>

            {/* Навигация */}
            <div className="flex items-center justify-between mt-8">
              {/* Пагинация (точки) - слева */}
              <div className="flex items-center gap-2">
                {teamMembers.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      currentSlide === index
                        ? 'bg-emerald-500 w-8'
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                    aria-label={`Перейти к сотруднику ${index + 1}`}
                  />
                ))}
              </div>

              {/* Кнопки навигации - справа */}
              <div className="flex items-center gap-3">
                <button
                  onClick={prevSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg hover:bg-emerald-500 transition-colors duration-300 cursor-pointer group border border-gray-100"
                  aria-label="Предыдущий сотрудник"
                >
                  <i className="ri-arrow-left-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
                </button>
                <button
                  onClick={nextSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg hover:bg-emerald-500 transition-colors duration-300 cursor-pointer group border border-gray-100"
                  aria-label="Следующий сотрудник"
                >
                  <i className="ri-arrow-right-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;